import React, { Fragment } from 'react'
import styled from 'styled-components'
import Logo from './logo'
import Burger from './burger'
import * as media from '../media'
import {browserHistory} from 'react-router'
import {withState} from 'recompose'
import yandex from '../static/icons/yandex.png'
import d from '../static/icons/D.png'
import vk from '../static/icons/vk.png'
import emailIcon from '../static/icons/email.svg'
import phoneIcon from '../static/icons/phone.svg'
import TranslateText from '../text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';

const MobileNav = styled.div`
  display: flex;
  justify-content: normal;
  align-items: flex-end;
  height: 90px;
  ${media.smallerThan(959)`
    height: 85;`
  }
`

const List = styled.ul`
  ${media.biggerThan(960)`display: flex;`}
  ${media.smallerThan(959)`display: none;`}
  justify-content: space-between;
  padding: 0 16px 4px 16px;
  margin-left: auto;
  margin-top: 20px;
  padding-right: 0;
  padding-bottom: 0;
  
  li {
    display: flex;
    padding: 6px 8px;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 25px;
    font-size: 16px;
    
    a {
      color: #5C707B;
      text-decoration: none;
      white-space: nowrap;
      font-weight: 600;
      
      &:hover {
        color: blue;
      }
    }
  }
`

const LogoHref = styled.a`
  margin-left: 10vw;
  margin-top: 18px;
  align-self: center;
  margin-bottom: 10px;
  cursor: pointer;
  ${media.smallerThan(1160)`margin-left: 22px; margin-right: auto;`}
  ${media.smallerThan(959)`margin-left: auto;`}
`

const BurgerWrapper = styled.div`
  ${media.biggerThan(960)`display:none;`}
`

const Icons = styled.div`
  display: flex;
  margin-left: 22px;
  margin-right: -10px;
  ${
    media.smallerThan(959)`
    position: absolute;
    right: 14px;
    top: 27px;
    `
  }
`

const IconsContainer = styled.div`
  margin-left: auto;
  margin-right: 10%;
  padding-left: 16px;
  align-self: center;
  margin-top: 3px;
  ${
    media.smallerThan(959)`
    margin-left: 0;
    margin-right: 0
    `
  }

  ${media.smallerThan(1160)` margin-right: 20px; margin-top: 0;`}
`;

const Contacts = styled.div`
  display: flex;
  margin-left: auto;
${
  media.smallerThan(959)`
    display: none;
  `
  }
`

const Postavka = styled.a`
  text-decoration: none;
  display: inline-block;
  transition: all .3s ease;
  color: #5C707B;
  cursor: pointer;
  margin-right: 3px;
  &:hover {
    color: blue;
  }
`

const Production = styled.a`
  cursor: pointer;
`

const ProductionContainer = styled.div `
  position: relative;
  &:hover {
    .ProductionMenu {
      display: block;
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 100;
      background: rgb(51,78,251);
      opacity: .9;
      padding: 10px 15px;
      width: max-content;
    }
  }
`;

const ProductionMenu = styled.div ` 
  display: none;
`;

const ProductionItem = styled.div`
  color: white;
  padding: 3px 0 3px 0;
  font-weight: normal;
  font-size: 14px;
  width: 230px;
  cursor: pointer;
  &: hover {
    font-weight: 600;
    margin-right: 0;
  }
`

const MobileSticky = styled.nav`
  ${media.smallerThan(960)`
    position: sticky;
    top: 0;
    z-index: 11;
    width: 100vw;
    max-width: 100%;
  `}
`

function Card({href, label}) {
  return (
    <ProductionItem
      onClick={() => {
        browserHistory.push(href)
      }}
    >
      {label}
    </ProductionItem>
  )
}

const Nav = () => (
  <MobileSticky
    style={{
      background: 'white',
      fontSize: 14,
      fontFamily: 'Montserrat'
    }}
  >
    <MobileNav>
      <LogoHref
        onClick={() => {
          browserHistory.push("/")
        }}
      >
        <Logo
          style={{
            cursor: 'pointer',
            display: 'inline-block',
          }}
        />
      </LogoHref>
      <IconsContainer>
      <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center',  color: '#5C707B', height: '40px' }}>
        <CurrentLanguageContext.Consumer>
          {currentLanguage => {
            return (
              <Fragment>
                <Contacts>
                  {currentLanguage !== 'ua' && currentLanguage !== 'en' &&
                    <div style={{display: 'inline-block'}}>
                      <img src={phoneIcon} style={{verticalAlign: 'middle', height: 18}}/>
                      <span style={{verticalAlign: 'middle', fontSize: '13px', marginLeft: 5}}>+7 (499) 426-36-27</span>
                    </div>
                  }
                  {currentLanguage !== 'ua' &&
                    <Postavka
                      href={currentLanguage === 'en' ? 'mailto:info@finwhale.eu' : 'mailto:postavka@finwhale.ru'}
                      style={{display: 'inline-block', marginLeft: 15, cursor: 'pointer'}}
                    >
                      <img style={{verticalAlign: 'middle', height: 16}} src={emailIcon}/>
                      <span style={{verticalAlign: 'middle', fontSize: '13px', marginLeft: 5}}>
                        {currentLanguage === 'en' ?
                          'info@finwhale.eu'
                          :
                          'postavka@finwhale.ru'
                        }
                      </span>
                    </Postavka>
                  }
                </Contacts>
                {currentLanguage !== 'ua' && currentLanguage !== 'en' &&
                  <Icons>
                    <img
                      src={yandex}
                      style={{marginLeft: 'auto', cursor: 'pointer', marginRight: '-6px', height: 40, display: 'inline-block'}}
                      onClick={() => {
                        window.location = 'http://zen.yandex.ru/id/5c8b644146a32a00b3fb6143'
                      }}
                    />
                    <img
                      src={vk}
                      style={{cursor: 'pointer', height: 40, marginRight: '-6px', display: 'inline-block'}}
                      onClick={() => {
                        window.location = 'https://vk.com/finwhale_russia'
                      }}
                    />
                    <img
                      src={d}
                      style={{cursor: 'pointer', height: 40, display: 'inline-block'}}
                      onClick={() => {
                        window.location = 'https://www.drive2.ru/o/Finwhale-page/'
                      }}
                    />
                  </Icons>
                }
              </Fragment>
            );
          }}
        </CurrentLanguageContext.Consumer>
      </div>
        
        <CurrentLanguageContext.Consumer>
          {currentLanguage => {
            return <List>
              <li>
                <ProductionContainer>
                  <Production onClick={() => browserHistory.push('/about')}>
                    <TranslateText id="nav_about_fw" place="top" />
                  </Production>
                  <ProductionMenu className='ProductionMenu'>
                    <Card
                      href={`/about`}
                      label={<TranslateText id="nav_about_fw__company" />}
                    />
                    <Card
                      href={`/news`}
                      label={<TranslateText id="nav_about_fw__news" />}
                    />
                  </ProductionMenu>
                </ProductionContainer>
              </li>
              <li>
                <ProductionContainer>
                  <Production onClick={() => browserHistory.push('/production')}>
                    <TranslateText id="nav_products" place="top" />
                  </Production>
                  <ProductionMenu className='ProductionMenu'>
                    <Card
                      href={`/clutch`}
                      label={<TranslateText id="nav_products__clutch_kit" />}
                    />
                    <Card
                      href={`/clutch-disc`}
                      label={<TranslateText id="nav_products__clutch_disc" />}
                    />
                    <Card
                      href={`/brake-pads`}
                      label={<TranslateText id="nav_products__brake_pads" />}
                    />
                    <Card
                      href={`/shocks`}
                      label={<TranslateText id="nav_products__absorbers" />}
                    />
                    <Card
                      href={`/high-tension-leads`}
                      label={<TranslateText id="nav_products__wires" />}
                    />
                    {currentLanguage != 'ua' ?
                      <Card
                        href={`/universal-joint`}
                        label={<TranslateText id="nav_products__crossews" />}
                      /> : ''
                    }
                    <Card
                      href={`/cv-joint`}
                      label={<TranslateText id="nav_products__shrus" />}
                    />
                    <Card
                      href={`/gas-spring`}
                      label={<TranslateText id="nav_products__gas_stops" />}
                    />
                    <Card
                      href={`/bearing`}
                      label={<TranslateText id="nav_products__wheel_bearings" />}
                    />
                    <Card
                      href={`/wipers-blade-fb`}
                      label={<TranslateText id="nav_products__wiper_blades_fb" />}
                    />
                    {/*
                    <Card
                      href={`/wipers-blade-hw`}
                      label={<TranslateText id="nav_products__wiper_blades_hw" />}
                    />
                    */}
                    <Card
                      href={`/wipers-blade-rx`}
                      label={<TranslateText id="nav_products__wiper_blades_rx" />}
                    />
                    <Card
                      href={`/timing-belt`}
                      label={<TranslateText id="nav_products__timing_belt" />}
                    />
                    <Card
                      href={`/belt-tensioner`}
                      label={<TranslateText id="nav_products__belt_tensioner" />}
                    />
                    <Card
                      href={`/belts`}
                      label={<TranslateText id="nav_products__drive_belts" />}
                    />
                    <Card
                      href={`/belts-v`}
                      label={<TranslateText id="nav_products__drive_belts_v" />}
                    />
                    <Card
                      href={`/belts-ribbed`}
                      label={<TranslateText id="nav_products__drive_belts_ribbed" />}
                    />
                    <Card
                      href={`/water-pump`}
                      label={<TranslateText id="nav_products__cooling_system_pumps" />}
                    />
                    <Card
                      href={`/thermostat`}
                      label={<TranslateText id="nav_products__termostats" />}
                    />
                    <Card
                      href={`/air-filter`}
                      label={<TranslateText id="nav_products__air_filters" />}
                    />
                    <Card
                      href={`/cabin-filter`}
                      label={<TranslateText id="nav_products__cabin_filters" />}
                    />
                    <Card
                      href={`/fuel-filter`}
                      label={<TranslateText id="nav_products__fuel_filters" />}
                    />
                    <Card
                      href={`/oil-filter`}
                      label={<TranslateText id="nav_products__oil_filters" />}
                    />
                    <Card
                      href={`/spark-plugs-iridium`}
                      label={<TranslateText id="nav_products__spark_plug_iridium" />}
                    />
                    <Card
                      href={`/spark-plugs-nicu`}
                      label={<TranslateText id="nav_products__spark_plug_nicu" />}
                    />
                    <Card
                      href={`/ball-joint`}
                      label={<TranslateText id="nav_products__ball_joint" />}
                    />
                    <Card
                      href={`/tie-rod-ends`}
                      label={<TranslateText id="nav_products__tie_rod_ends" />}
                    />
                    <Card
                      href={`/silent-block`}
                      label={<TranslateText id="nav_products__silent_block" />}
                    />
                    <Card
                      href={`/stabilizer-link`}
                      label={<TranslateText id="nav_products__stabilizer_link" />}
                    />
                    <Card
                      href={`/ignition-coil`}
                      label={<TranslateText id="nav_products__katushki" />}
                    />
                  </ProductionMenu>
                </ProductionContainer>
              </li>
              <li>
                <ProductionContainer>
                  <Production onClick={() => browserHistory.push('/partners')}>
                    <TranslateText id="nav_partners" place="top" />
                  </Production>
                </ProductionContainer>
              </li>
              <li>
                <ProductionContainer>
                  <Production onClick={() => browserHistory.push('/retail-stores')}>
                    <TranslateText id="nav_where_buy" place="top" />
                  </Production>
                </ProductionContainer>
              </li>
            </List>
          }}
        </CurrentLanguageContext.Consumer>
      </IconsContainer>

      <BurgerWrapper>
        <Burger/>
      </BurgerWrapper>
    </MobileNav>
  </MobileSticky>
)

export default withState('searchSelected', 'setSearchSelected', false)(Nav)



// WEBPACK FOOTER //
// ./src/finwhale/nav.js